export const dev = {
  MODE: 'development',
  // BASE_URL: 'https://test-api.jufair.com/api', // 测试环境
  BASE_URL: 'http://pre-api.jufair.com/api', // 预发环境·
  // API_BASE_URL: 'https://api.jufair.com', // 客户端发送请求
  // BASE_URL: 'https://test.jufair.com/api', // 生产环境
  // BASE_URL: 'https://www.jufair.com/api',
  HOST_NAME: 'http://localhost:7001',
  // HOST_NAME: 'https://test-api.jufair.com',
  HOST_NAME_EN: 'http://localhost:7001',
  HOTEL: 'https://hotel-dev.jufair.com',
  VISA: 'https://visa-dev.jufair.com',
  OSS_HOST: 'https://jufair.oss-accelerate.aliyuncs.com',
  OSS_HOST_INTERNAL: 'https://jufair.oss-accelerate.aliyuncs.com',
  toPath_url: 'localhost:7001',
  static_url: '',
  // OSS_HOST_INTERNAL: 'https://dcdn-jufair-test.jufair.com' // cdn
  // OSS缓存配置
  OSS_CACHE_REGION: 'oss-cn-shanghai',
  OSS_CACHE_ENDPOINT: 'oss-cn-shanghai.aliyuncs.com',
  OSS_CACHE_ACCESS_KEY_ID: process.env.OSS_ACCESS_KEY_ID,
  OSS_CACHE_ACCESS_KEY_SECRET: process.env.OSS_ACCESS_KEY_SECRET,
  OSS_CACHE_BUCKET: 'jufair-cache-dev',
  OSS_CACHE_REVALIDATION_TTL: 30 * 1000,
  OSS_CACHE_ENABLED: false // oss缓存 true开启, false关闭
}
export const test = {
  MODE: 'test',
  BASE_URL: 'http://jufair-back', // 测试服务器地址
  API_BASE_URL: 'https://vue.jufair.com',
  // BASE_URL: 'https://pre-api.jufair.com/api', // 预发环境
  // BASE_URL: 'https://www.jufair.com/api',
  HOST_NAME: 'https://vue.jufair.com',
  // HOST_NAME: 'https://www.jufair.com',
  HOST_NAME_EN: 'https://en.jufair.com',
  HOTEL: 'https://hotel-dev.jufair.com',
  VISA: 'https://visa-dev.jufair.com',
  OSS_HOST: 'https://jufair-test.oss-accelerate.aliyuncs.com', // 外网
  OSS_HOST_INTERNAL: 'https://jufair-test.oss-cn-shanghai-internal.aliyuncs.com', // 内网
  toPath_url: 'vue.jufair.com',
  static_url: 'https://w3-file.jufair.com/test/',
  // OSS缓存配置
  OSS_CACHE_REGION: 'oss-cn-shanghai',
  OSS_CACHE_ENDPOINT: 'oss-cn-shanghai-internal.aliyuncs.com',
  OSS_CACHE_ACCESS_KEY_ID: process.env.OSS_ACCESS_KEY_ID,
  OSS_CACHE_ACCESS_KEY_SECRET: process.env.OSS_ACCESS_KEY_SECRET,
  OSS_CACHE_BUCKET: 'jufair-cache-test',
  OSS_CACHE_REVALIDATION_TTL: 5 * 60 * 1000,
  OSS_CACHE_ENABLED: false
}
export const prod = {
  MODE: 'production',
  BASE_URL: 'http://alb-tiyse0b19w0v7p3iu4.cn-shanghai.alb.aliyuncsslb.com', //'http://alb-ycdypmc9cjziyflu4i.cn-shanghai.alb.aliyuncsslb.com:7201', // 正式服务器地址

  // BASE_URL: 'https://www.jufair.com/api',
  HOST_NAME: 'https://www.jufair.com',
  HOST_NAME_EN: 'https://en.jufair.com',
  HOTEL: 'https://hotel.jufair.com',
  VISA: 'https://visa.jufair.com',
  OSS_HOST: 'https://jufair.oss-accelerate.aliyuncs.com', // 外网
  OSS_HOST_INTERNAL: 'https://jufair.oss-cn-shanghai-internal.aliyuncs.com', // 内网
  toPath_url: 'www.jufair.com',
  static_url: 'https://w3-file.jufair.com/prod/',
  API_BASE_URL: 'https://api.jufair.com',
  // OSS缓存配置
  OSS_CACHE_REGION: 'oss-cn-shanghai',
  OSS_CACHE_ENDPOINT: 'oss-cn-shanghai-internal.aliyuncs.com',
  OSS_CACHE_ACCESS_KEY_ID: process.env.OSS_ACCESS_KEY_ID,
  OSS_CACHE_ACCESS_KEY_SECRET: process.env.OSS_ACCESS_KEY_SECRET,
  OSS_CACHE_BUCKET: 'jufair-cache-prod',
  OSS_CACHE_REVALIDATION_TTL: 5 * 60 * 1000,
  OSS_CACHE_ENABLED: true
}
export const spider = {
  MODE: 'production',
  BASE_URL: 'http://alb-tiyse0b19w0v7p3iu4.cn-shanghai.alb.aliyuncsslb.com:7201', // 正式服务器地址
  // BASE_URL: 'https://www.jufair.com/api',
  HOST_NAME: 'https://www.jufair.com',
  HOST_NAME_EN: 'https://en.jufair.com',
  HOTEL: 'https://hotel.jufair.com',
  VISA: 'https://visa.jufair.com',
  OSS_HOST: 'https://jufair.oss-accelerate.aliyuncs.com', // 外网
  OSS_HOST_INTERNAL: 'https://jufair.oss-cn-shanghai-internal.aliyuncs.com', // 内网
  toPath_url: 'www.jufair.com',
  static_url: 'https://w3-file.jufair.com/prod/',
  API_BASE_URL: 'https://api.jufair.com',
  // OSS缓存配置
  OSS_CACHE_REGION: 'oss-cn-shanghai',
  OSS_CACHE_ENDPOINT: 'oss-cn-shanghai-internal.aliyuncs.com',
  OSS_CACHE_ACCESS_KEY_ID: process.env.OSS_ACCESS_KEY_ID,
  OSS_CACHE_ACCESS_KEY_SECRET: process.env.OSS_ACCESS_KEY_SECRET,
  OSS_CACHE_BUCKET: 'jufair-cache-prod',
  OSS_CACHE_REVALIDATION_TTL: 5 * 60 * 1000,
  OSS_CACHE_ENABLED: false
}
export const pre = {
  MODE: 'pre',
  // BASE_URL: 'http://jufair-back-pre', // 预发服务器地址 pre-api.jufair.com/api
  // BASE_URL: 'https://pre-pc.jufair.com/api', // 预发环境  https://pre-api.jufair.com/api
  BASE_URL: 'https://pre-api.jufair.com/api', // 预发环境

  // BASE_URL: 'https://www.jufair.com/api',
  HOST_NAME: 'https://pre-pc.jufair.com',
  HOST_NAME_EN: 'https://en.jufair.com', // 英文站域名
  HOTEL: 'https://hotel.jufair.com',
  VISA: 'https://visa.jufair.com',
  OSS_HOST: 'https://jufair.oss-accelerate.aliyuncs.com', // 外网
  OSS_HOST_INTERNAL: 'https://jufair.oss-cn-shanghai-internal.aliyuncs.com', // 内网
  toPath_url: 'pre-pc.jufair.com',
  static_url: 'https://w3-file.jufair.com/pre/',
  // API_BASE_URL: 'https://api.jufair.com',
  API_BASE_URL: '',
  // OSS缓存配置
  OSS_CACHE_REGION: 'oss-cn-shanghai',
  OSS_CACHE_ENDPOINT: 'oss-cn-shanghai-internal.aliyuncs.com',
  OSS_CACHE_ACCESS_KEY_ID: process.env.OSS_ACCESS_KEY_ID,
  OSS_CACHE_ACCESS_KEY_SECRET: process.env.OSS_ACCESS_KEY_SECRET,
  OSS_CACHE_BUCKET: 'jufair-cache-pre',
  OSS_CACHE_REVALIDATION_TTL: 5 * 60 * 1000,
  OSS_CACHE_ENABLED: false
}
export const edge = {
  MODE: 'edge',
  BASE_URL: 'https://api.jufair.com/api', // 正式服务器地址
  HOST_NAME: 'https://www.jufair.com',
  HOST_NAME_EN: 'https://en.jufair.com',
  HOTEL: 'https://hotel.jufair.com',
  VISA: 'https://visa.jufair.com',
  OSS_HOST: 'https://jufair.oss-accelerate.aliyuncs.com', // 外网
  OSS_HOST_INTERNAL: 'https://jufair.oss-accelerate.aliyuncs.com', // 内网
  toPath_url: 'www.jufair.com',
  static_url: 'https://w3-file.jufair.com/prod/',
  API_BASE_URL: 'https://api.jufair.com',
  // OSS缓存配置
  OSS_CACHE_REGION: 'oss-cn-hongkong',
  OSS_CACHE_ENDPOINT: 'oss-cn-hongkong-internal.aliyuncs.com',
  OSS_CACHE_ACCESS_KEY_ID: process.env.OSS_ACCESS_KEY_ID,
  OSS_CACHE_ACCESS_KEY_SECRET: process.env.OSS_ACCESS_KEY_SECRET,
  OSS_CACHE_BUCKET: 'jufair-cache-hk',
  OSS_CACHE_REVALIDATION_TTL: 5 * 60 * 1000,
  OSS_CACHE_ENABLED: true
}
